module.exports = __webpack_public_path__ + "img/icon-invoice.9dcf9ee5.svg";